import { api } from '../utils/variables';
import axios from 'axios';

const sidequestApi = axios.create({
  baseURL: api,
});

// Submit a Sidequest partner pre-registration request
export const submitSidequestPreRegistration = async (data) => {
  try {
    const response = await sidequestApi.post('/external-registration/', data);
    return response.data;
  } catch (error) {
    console.error('Error submitting Sidequest pre-registration:', error);
    throw error;
  }
};

export default sidequestApi;
